<template>
  <div class="mine">
    <el-table stripe :data="tableData" :key="itemKey">
      <el-table-column show-overflow-tooltip prop="title" label="标题" width="480">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top" width="480">
            <p>{{ scope.row.content }}</p>
            <div slot="reference" class="name-wrapper">
              {{ scope.row.title }}
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="category" label="分类" width="180">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag size="medium" :type="status2Tag(scope.row.status)">{{ scope.row.status }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="modified" label="更新日期" width="160">
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <el-button v-if="canEdit(scope.row)" type="text" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button v-if="canEdit(scope.row)" type="text" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>确认要删除这个需求吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteStory">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, delete as del } from 'axios';
export default {
  data() {
    return {
      dialogVisible: false,
      rowSelected: {},
      user: window.globalData?.user || {},
      storyData: [],
      tableData: [],
      globalData: {},
      itemKey: Math.random()
    }
  },
  methods: {
    status2Tag(status) {
      console.log("status2Tag: " + status)
      const tagMap = new Map()
      this.globalData.config.tagList.forEach(element => {
        tagMap.set(element.value, element.label)
      })
      return tagMap.get(status)
    },
    async deleteStory() {
      console.log("Delete story: ")
      console.log(this.rowSelected)
      if (this.rowSelected.id) {
        let { data } = await del('api/opinions/delete?id=' + this.rowSelected.id)
        console.log("result of delte story: " + data)
        this.refreshStoryList()
      }
      this.dialogVisible = false
    },
    async refreshStoryList() {
      let { data } = await get('api/opinions/list?creator=' + this.user.userid)
      if (data.code === 0) {
        console.log(data)
        this.storyData = data.data || []

        const categoryMap = new Map()
        this.globalData.config.categoryList.forEach(element => {
          categoryMap.set(element.value, element.label)
        })

        const statusMap = new Map()
        this.globalData.config.statusList.forEach(element => {
          statusMap.set(element.value, element.label)
        })

        this.tableData.length = 0

        this.storyData.forEach(element => {
          console.log(element)
          var item = { id: element.id, title: element.title, content: element.text, category: categoryMap.get(element.category), status: statusMap.get(element.status), modified: element.modified }
          this.tableData.push(item)
        });

        this.itemKey = Math.random()
      } else {
        this.$message.error('读取列表失败!')
      }
    },
    canEdit(row) {
      console.log("Story status: " + row.status)
      if (row.status !== '实现中' && row.status !== '已实现') {
        return true
      }
      else {
        return false
      }
    },
    handleEdit(row) {
      console.log("handleEdit: " + row.id)
      this.rowSelected = row
      console.log(this.rowSelected)

      this.$bus.emit("edit", row.id);
    },
    handleDelete(row) {
      console.log("handleDelete: ")
      this.rowSelected = row
      console.log(this.rowSelected)
      this.dialogVisible = true
    }
  },
  mounted() {
    this.globalData = window.globalData;

    console.log("user: " + this.user)

    if (!this.user.userid) {
      console.log("userid not found!")
      return
    }

    this.refreshStoryList()
  }
}
</script>

<style>
.mine {
  padding: 40px;
  width: 1040px;
}
</style>
